import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { SuccessMessageService } from '@shared/services/success-message.service'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-success-message',
  imports: [TranslatePipe],
  templateUrl: './success-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './success-message.component.scss',
})
export class SuccessMessageComponent {
  successMessageService = inject(SuccessMessageService)

  reset() {
    this.successMessageService.reset()
  }
}
